<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="news w">
    <Row class="component-title">
      <Col span="18">新闻热点</Col>
      <Col span="6" class="text-right">
        <Button type="text" class="view-all">
          查看全部
          <Icon type="ios-arrow-forward" />
        </Button>
      </Col>
    </Row>
    <Row class="news-content">
      <Col span="12" class="h-full relative pr-16px pt-74px">
        <div
          class="news-content-box w-full h-full relative overflow-hidden"
          :style="`background-image: url(${item.image});`"
        >
          <Row
            type="flex"
            justify="center"
            align="top"
            class="w-full news-detail absolute pin-b pin-l"
          >
            <Col span="18" class="detail-text">
              <div class="title">{{ item.title }}</div>
              <div>
                {{ item.content }}
              </div>
            </Col>
            <Col span="6" class="text-right time">
              {{ item.time }}
            </Col>
          </Row>
        </div>
      </Col>
      <Col span="12" class="h-full pl-16px">
        <ul class="swiper h-full">
          <li
            v-for="item in swiper"
            :key="item.id"
            class="slide w-full cursor-pointer"
            :class="
              !selected
                ? 'h-one-third'
                : selected == item.id
                ? 'active'
                : 'h-active-small'
            "
          >
            <Row
              type="flex"
              justify="center"
              align="top"
              class="w-full swiper-detail relative"
            >
              <Col span="18" class="swiper-text">
                <div class="title">{{ item.title }}</div>
                <div>
                  {{ item.content }}
                </div>
              </Col>
              <Col span="6" class="text-right time">
                {{ item.time }}
              </Col>
              <Col span="24" class="text-left pt-25px">
                <Button
                  type="text"
                  class="more"
                  @click.native="link(item.link)"
                >
                  查看详情<Icon type="ios-arrow-forward" />
                </Button>
              </Col>
            </Row>
          </li>
        </ul>
        <!-- <swiper class="swiper h-full" :options="hooperSettings">
          <swiper-slide
            v-for="item in swiper"
            :key="item.id"
            class="slide w-full"
          >
            <Row
              type="flex"
              justify="center"
              align="top"
              class="w-full swiper-detail relative"
            >
              <Col span="18" class="swiper-text">
                <div class="title">{{ item.title }}</div>
                <div>
                  {{ item.content }}
                </div>
              </Col>
              <Col span="6" class="text-right time">
                {{ item.time }}
              </Col>
              <Col span="24" class="text-left pt-25px">
                <Button type="text" class="more">
                  查看详情<Icon type="ios-arrow-forward" />
                </Button>
              </Col>
            </Row>
          </swiper-slide>
        </swiper> -->
      </Col>
    </Row>
  </div>
</template>

<script>
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'

export default {
  name: 'NewsComponent',
  props: {},
  mixins: [],
  components: {
    // swiper,
    // swiperSlide
  },
  data() {
    return {
      selected: null,
      item: {
        id: 'a-1',
        title: '2016-2045年',
        content: '新兴科技趋势报告',
        link: 'waiting',
        image: '/static/images/background/news.png',
        time: '07-12'
      },
      swiper: [
        {
          id: '1',
          title: '全球首批生命时空图谱发布！',
          content:
            '焕生汇凭借在生物科技领域的突出表现，一举斩获“2022年度生物技术服务领先企业”',
          link: 'waiting',
          image: '/static/images/background/news.png',
          time: '10-12'
        },
        {
          id: '2',
          title: '全基因组测序揭示了精神分裂症的遗传结构秘密',
          content:
            '“通过Stereo-seq（时空组学技术），人类首次以500纳米的空间分辨率实现了生命全景时空图谱的绘制。这是生命科学工具的里程碑式突破。',
          link: 'waiting',
          image: '/static/images/background/achievement2.png',
          time: '07-12'
        },
        {
          id: '3',
          title: '全基因组测序揭示了精神分裂症的遗传结构秘密',
          content:
            '起源于几千年前的中华“阴阳”思想，被应用于今天的生物学技术领域，并可能逐步改变未来的大数据产业发展',
          link: 'waiting',
          image: '/static/images/background/achievement3.png',
          time: '07-03'
        }
      ],
      hooperSettings: {
        slidesPerView: 3,
        spaceBetween: 0,
        direction: 'vertical',
        mousewheel: true,
        loop: true,
        centeredSlides: true
        // effect: 'fade',
        // autoplay: {
        //   delay: 3500,
        //   disableOnInteraction: false
        // }
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // }
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {
    link(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';

.news {
  padding-bottom: 5.625vw; //108px;
  .component-title {
    padding: 4.95vw 0 0 0; //95px 0 0 0;
  }
  .news-content {
    height: 33vw; //634px;
  }
  .news-content-box {
    background-image: url('/static/images/background/news.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: top center;
    border-radius: 4px 4px 0 0;
  }

  .news-detail {
    height: 8.85vw; //170px;
    background-color: $c-white;
    padding: 2.24vw 2.66vw 2.24vw 2.24vw; //43px 51px 43px 43px;
    position: absolute;
    background-color: #fafafa;
    border-radius: 0 0 4px 4px;
  }
  .detail-text {
    color: #646a77;
    font-size: 1.5625vw;
  }
  .time {
    color: #b9bcc1;
    font-size: 2.08vw;
    line-height: 1.2;
  }
  .swiper {
    .more {
      display: none;
      color: $c-white;
      padding: 0;
      font-size: 0.885vw;
      &:hover {
        background-color: $c-transparent;
      }
    }
    .slide {
      //.swiper-slide {
      padding: 3.85vw 2.6vw 0px 2.8125vw; //74px 50px 0px 54px;
      margin-bottom: 0;
      border-bottom: 1px solid #f0f1f2;
    }
    .slide:hover,
    .slide.active {
      //.swiper-slide-active {
      height: 38% !important;
      background: linear-gradient(271.59deg, #3fb7b0 7.71%, #239c95 87.9%);
      padding: 2.97vw 2.6vw 0 2.8125vw;
      .swiper-text {
        color: $c-white;
        .title {
          color: $c-white;
        }
      }
      .time {
        color: $c-white;
      }
      .more {
        display: inline-block;
      }
    }
    .swiper-text {
      color: #646a77;
      font-size: 0.885vw;

      .title {
        color: #111a2e;
        font-size: 1.15vw;
        margin-bottom: 0.73vw;
      }
    }
    .time {
      font-size: 1.5625vw;
    }
  }
  .view-all {
    font-size: 1.25vw;

    color: #303849;
    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
    &:hover {
      color: #46bfb8;
    }
  }
}
.pr-16px {
  padding-right: 0.83vw;
}
.pl-16px {
  padding-left: 0.83vw;
}
.pt-25px {
  padding-top: 1.3vw;
}
.pt-74px {
  padding-top: 3.85vw;
}
.h-one-third {
  height: 33.3% !important;
}
.h-active-small {
  height: 31% !important;
}
</style>
